import { useState, useEffect, useRef, useCallback } from 'react'
import IdleTimer from 'react-idle-timer'
import { withRouter } from 'react-router-dom'
import ErrorBoundary from '../Components/ErrorBoundary'
import { odinUserRepository } from '../../refactory/modules/access-control/infrastructure/odin-user.repository'
import { updateUserV3UseCase } from '../../refactory/modules/access-control/application/update-user-v3.use-case'
import { AccessControl } from '../../refactory/modules/access-control/infrastructure/roles-permissions/access-control'
import { getI18n } from 'react-i18next'
import Routes from '../Components/Routes/Scenes'
import LoadingContainer from '../Components/Loading/Scenes'
import { Notifications } from '../../refactory/kernel/infrastructure/notifications/Notifications.component'
import { getParams } from '../Services/Params/api'
import ModalInactive from './ModalInactive'
import { useAuth } from '../../auth/Auth.hook'
import { BRAND } from '@/shared/brand/brand.config'

let idleTimer = null
const INACTIVITY_TIMEOUT = 'inactivityTimeout'
const ENTERPRISE = 'enterprise'
const HAS_ECOMMERCE = 'hasEcommerce'

setTimeout(function () {
  window.local = getI18n().language
}, 3000)

const toObject = (values) => {
  let obj = {}
  values.forEach(({ key, value }) => {
    obj[key] = value
  })
  return obj
}

const IS_DEVELOPMENT = import.meta.env.VITE_ENV === 'development'

export default withRouter((props) => {
  const { userInfo, getUserProfile, isAuthenticated, loading, loginError, logout, updateUserInfo } = useAuth()

  const [showModal, setShowModal] = useState(false)
  const firstLoadRef = useRef(false)
  const [timeout, setLocalTimeout] = useState(0)
  const [hasECommerce, setHasEcommerce] = useState(false)
  const [featureFlags, setFeatureFlags] = useState({})
  const logoutRef = useRef(logout)
  logoutRef.current = logout

  const getClientParams = useCallback(async () => {
    try {
      const params = await getParams()
      if (params && params.length) {
        const paramsObject = toObject(params)
        setFeatureFlags(paramsObject)
        setHasEcommerce(paramsObject[HAS_ECOMMERCE] === 'true')
        setLocalTimeout((prev) => {
          if (prev === 0) {
            return Number(paramsObject[INACTIVITY_TIMEOUT] || 1800000)
          }
          return prev
        })
        idleTimer && idleTimer.reset()
        updateUserInfo((prevInfo) =>
          prevInfo ? { ...prevInfo, isSSO: paramsObject[ENTERPRISE] === 'true' } : prevInfo
        )
      }
    } catch (error) {
      console.error('something went wrong getting the client params')
    }
  }, [updateUserInfo])

  useEffect(() => {
    if (firstLoadRef.current) return
    if (!loading && isAuthenticated && !loginError && AccessControl.abilityInstance && userInfo) {
      firstLoadRef.current = true
      const currentLocation = `${props.location.pathname}${props.location.search}`
      if (currentLocation) {
        props.history.push(currentLocation)
      }
      getClientParams()
    }
    if (loginError) {
      console.log('Show error window')
    }
  }, [isAuthenticated, loading, loginError, getClientParams])

  useEffect(() => {
    if (loginError) {
      if (!IS_DEVELOPMENT) {
        logoutRef.current({ federated: userInfo?.isSSO })
      } else {
        logoutRef.current()
      }
    }
  }, [loginError])

  const onIdle = async () => {
    const { user } = userInfo
    if (timeout !== 0) {
      if (user && user.isLive) {
        await updateUserV3UseCase(odinUserRepository)(user.id, { isLive: false })
        getUserProfile()
        setShowModal(true)
      }
    }
  }

  const getView = (_) => {
    if (loading || !AccessControl.abilityInstance) {
      return (
        <div className='pre-loading'>
          <img src={BRAND.splash.logoUrl} alt={BRAND.splash.alt} />
        </div>
      )
    } else if (!loginError) {
      return <Routes currentUser={userInfo} hasECommerce={hasECommerce} featureFlags={featureFlags} />
    } else {
      return null
    }
  }

  const client = userInfo?.client
  return !isAuthenticated || !userInfo?.user?.email ? null : (
    <ErrorBoundary>
      <IdleTimer
        ref={(ref) => {
          idleTimer = ref
        }}
        onIdle={onIdle}
        timeout={timeout || 1800000}
        startOnLoad
      >
        {getView()}
        <LoadingContainer color={client?.styles['@primary-color']} />
        <Notifications user={userInfo.user} />
      </IdleTimer>
      <ModalInactive showModal={showModal} setShowModal={setShowModal} timeout={timeout > 0 ? timeout / 60000 : 0} />
    </ErrorBoundary>
  )
})
